'use strict';

import { partial } from 'lodash';

var React = require('react');
var ComponentFactory = require('../../../infrastructure/ComponentFactory');

/** @module ThumbnailYoutube
 * @requires lodash
 * @requires react
 * @requires ComponentFactory
 */
var ThumbnailVimeo = ComponentFactory.Create({
	displayName: "ThumbnailVimeo",
	propTypes: {
		contentItem: React.PropTypes.object.isRequired,
		picked: React.PropTypes.bool,
		onPick: React.PropTypes.func,
		onDelete: React.PropTypes.func
	},

	/**
	 * @method render
	 */
	render: function() {
		var url = this.props.contentItem.url;
		return (
			<div
				onClick={this.props.onPick && partial(this.props.onPick, this.props.contentItem)}
				className={this.css("image-library-thumbnail vimeo-thumbnail", {"picked": this.props.picked})}
				style={{ backgroundImage: 'url("' + url + '")'}}
			>
				<div className="details">
					<div className="icon">
						<i className="mdi mdi-vimeo" />
					</div>
					<div className="title">
						<p>{this.props.contentItem.title}</p>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = ThumbnailVimeo;
